import React from "react";
import { Link } from "react-router-dom";

/**
 * 渲染普通商品询价页右侧联系方式。
 */
export default function ContactDetails() {
  return (
    <div className="w-full lg:w-1/3 p-4">
      <h2 className="text-2xl font-bold">Contact Details</h2>
      <p className="mt-2 text-lg text-gray-800">
        Creatyea Technology (SZ) CO Limited,
        <br />
        RM1903 - 1905, 19/F, Qiu Shi, West BLDG, Zhu Zi Lin, Fu Tian Estate,
        Shen Zhen, 518031 GD, China.
      </p>
      <Link
        className="text-blue-600 hover:text-blue-800 mt-3 block"
        to="mailto:hello@creatyea.com"
      >
        hello@creatyea.com
      </Link>
      <Link
        className="text-blue-600 hover:text-blue-800 mt-3 block"
        to="tel:+8613538239881"
      >
        +86-13538239881
      </Link>
    </div>
  );
}
